import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import React, { Component } from 'react';

import 'client/components/text/index.css';
import './index.css';

const b = cn('text-no-data');

interface Props {
    text?: string;
}

export default class TextNoData extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { text } = this.props;
        const { dictionary } = this.context;

        const textHtml = text ? text : dictionary.not_get_data;

        return (
            <div
                className={b()}
                dangerouslySetInnerHTML={{ __html: textHtml }}
                />
        );
    }

}
